import { Component } from '@angular/core';

import { DashboardSystemComponent } from './dashboard-system.component';

@Component({
  selector: 'app-dashboard-system-financial',
  standalone: true,
  imports: [DashboardSystemComponent],
  template: `
    <app-dashboard-system
      [dashboardLayout]="'SYSTEM_FINANCIAL'"
      [pageTitle]="'Financial operations'"
      [pageSubtitle]="'Wallets, liquidity, and transaction flows'"
    />
  `,
})
export class DashboardSystemFinancialComponent {}
